export const email = "sourishmukherjee.official@gmail.com";

export const CONTACT_DETAILS = {
	email
};
